export default __webpack_public_path__ + "31bd8be.png";